module.exports = __webpack_public_path__ + "img/sydney.0992cdee.png";